class LayerSensor {
	
	constructor(context) {
		
		this.scenario = context.tc.scenario;
		this.map = context.tc.draw.map;
		this.du = context.tc.draw;
		this.tc = context.tc;
		this.context = context;
		this.currentSensor = false;
		this.currentSensorIdx = false;
		
	}
	
	json(){
		var points = this.scenario.nsas.slice(0);	
		LayerSensor.data = {
			"type":"FeatureCollection",
			"features":[]
		};
			
		LayerSensor.data.features = points.map((f, idx)=>{
			f.type = 'Feature';
			
			f.properties = {...f.properties};
			if(isNaN(f.nsaid))
				f.properties.tempid = f.nsaid;
			else
				f.id = f.nsaid;
			
			f.properties.idx = idx;
			f.properties.nsaid = f.nsaid;
			f.properties.name=f.name ? f.name : 'Sensor '+f.sensorid;
			return f;
		});
		
		const l = {
			'images': [
				{
					'src': '/images/icons/nsa_marker.png',
					'name': 'nsamarker'
				},
				{
					'src': '/images/icons/nsa_marker_hover.png',
					'name': 'nsamarker_hover'
				},
				{
					'src': '/images/icons/nsa_marker_on.png',
					'name': 'nsamarker_on'
				}
			],
			'source': {
				'id': LayerSensor.sourceId,
				'type': 'geojson',
				'data': LayerSensor.data
			},
			'layer': [
				{
					'id': LayerSensor.layerId,
					'type': 'symbol',
					'source': LayerSensor.sourceId,
					"paint": {
						'text-color': "#000000", //Color of your choice
						'text-halo-width': 1,
						'text-halo-color': "#ffffff",
					}, // reference the data source
					'layout': {
						'icon-image':['case',
							['boolean', ['get', 'invisible'], false],'',
							['boolean', ['get', 'selected'], false],'nsamarker_on',
							['boolean', ['get', 'hover'], false],'nsamarker_hover',
							'nsamarker'
						],
						'icon-anchor' : 'bottom',
						'icon-allow-overlap' : true,
						'text-field': ['case',
							['boolean', ['get', 'invisible'], false],'',
							['get', 'name']
						]	
						, //This will get "t" property from your geojson
						'text-rotation-alignment': "auto",
						'text-allow-overlap': true,
						'text-anchor': "top",
						'text-size': 14,
					},
				}
			]
		};
		return l;
	}
	
		
}

LayerSensor.layerId = 'sensors_layer';
LayerSensor.sourceId = 'sensors_source';


export default LayerSensor;